import {
	StatesAndProvinces,
	StatesAndProvincesDto,
} from 'api/v1/data-contracts';
import { _ReturnNull } from 'i18next';

import { IdLabelDto } from '../Common/IdLabelDto';

export const mapStatesAndProvincesDtoToIdLabelCountry = ({
	abbreviation: id,
	name: label,
}: StatesAndProvincesDto): IdLabelDto => ({
	id,
	label,
});

export const isStatesAndProvinces = (
	countryCode?: string | null
): countryCode is StatesAndProvinces =>
	countryCode ? ['US', 'CA'].includes(countryCode) : false;
